import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { LoaderComponent } from './loader';

@NgModule({
    imports: [CommonModule, MatProgressSpinnerModule],
    declarations: [LoaderComponent],
    exports: [LoaderComponent, MatProgressSpinnerModule],
})
export class LoaderModule {}
